

export const quizlanguages = [
    {
        "id":0,
        "language":"English",
    },
    {
        "id":1,
        "language":"Arabic",
    },
    {
        "id":2,
        "language":"Chinese",
    },
    {
        "id":3,
        "language":"Czech",
    },
    {
        "id":4,
        "language":"Danish",
    },
    {
        "id":5,
        "language":"French",
    },
    {
        "id":6,
        "language":"German",
    },
    {
        "id":7,
        "language":"Greek",
    },
    {
        "id":8,
        "language":"Hungarian",
    },
    {
        "id":9,
        "language":"Italian",
    },
    {
        "id":10,
        "language":"Japanese",
    },
    {
        "id":11,
        "language":"Korean",
    },
    {
        "id":12,
        "language":"Polish",
    },
    {
        "id":13,
        "language":"Portuguese",
    },
    {
        "id":14,
        "language":"Romanian",
    },
    {
        "id":15,
        "language":"Russian",
    },
    {
        "id":16,
        "language":"Serbian",
    },
    {
        "id":17,
        "language":"Spanish",
    },
    {
        "id":18,
        "language":"Swedish",
    },
    {
        "id":19,
        "language":"Turkish",
    },
]

export const quizsamples = [
    {
        "id":0,
        "topic":"Napoleon",
        "language":"English",
        "chatname":"Napoleon",
        "promptsandresponses":[
            {
                "id":0,
                "prompt":"Question?",
                "response":"What were some of the key factors that contributed to Napoleon's rise to power in France?"
            },
            {
                "id":1,
                "prompt":"The French Revolution and overthrow of France monarchy.",
                "response":"Your answer is correct! The French Revolution and the overthrow of the French monarchy were indeed key factors that contributed to Napoleon's rise to power in France."
            },
            {
                "id":2,
                "prompt":"Question?",
                "response":"What were some of the biggest mistakes Napoleon made during his reign as emperor of France?"
            },
            {
                "id":3,
                "prompt":"Probably the biggest mistake was a war with Russia.",
                "response":"Correct! Napoleon's invasion of Russia in 1812 was a major mistake that ultimately led to his downfall. Other mistakes include the Continental System, which hurt French trade and angered other European powers, and the Peninsular War in Spain, which drained French resources and created a guerrilla war that lasted for years."
            }
        ]
    },
    {
        "id":1,
        "topic":"Solar system",
        "language":"English",
        "chatname":"Solar System",
        "promptsandresponses":[
            {
                "id":0,
                "prompt":"Question?",
                "response":"What is the largest moon in the Solar System and which planet does it belong to?"
            },
            {
                "id":1,
                "prompt":"The largest moon in the Solar System is Europa and it belongs to Jupiter.",
                "response":"Correct! Europa is indeed the largest moon in the Solar System and it belongs to Jupiter."
            },
            {
                "id":2,"prompt":"Question?","response":"Which planet in the Solar System has the longest day and how long is it?"
            },
            {
                "id":3,
                "prompt":"Jupiter has the longest day, but I don't know how long it is.",
                "response":"Your answer is partially correct. Jupiter does have the longest day of any planet in the Solar System, but its day lasts about 9.9 Earth hours."
            }
        ]
    },
    {
        "id":2,
        "topic":"Lions",
        "language":"English",
        "chatname":"Lions",
        "promptsandresponses":[
            {
                "id":0,
                "prompt":"Question?",
                "response":"What is the average lifespan of a lion in the wild?"
            },
            {
                "id":1,
                "prompt":"10 years.",
                "response":"Your answer is partially correct. The average lifespan of a lion in the wild is actually around 14 years. However, in captivity, they can live up to 20 years or more."
            },
            {
                "id":2,
                "prompt":"Question?",
                "response":"What is the typical hunting strategy of a lion pride?"
            },
            {
                "id":3,
                "prompt":"Lions stalk their prey.",
                "response":"That is partially correct. Lions do stalk their prey, but their typical hunting strategy involves working together in a coordinated attack to isolate and bring down their prey. This often involves one or more lions chasing the prey while others wait in ambush to cut off escape routes or launch surprise attacks."
            }
        ]
    },
    {
        "id":3,
        "topic":"John F Kennedy",
        "language":"English",
        "chatname":"John F Kennedy",
        "promptsandresponses":[
            {
                "id":0,
                "prompt":"Question?",
                "response":"What was the significance of John F Kennedy's famous \"Ich bin ein Berliner\" speech?"
            },
            {
                "id":1,
                "prompt":"The speech is considered one of Kennedy's finest, delivered at the height of the Cold War and the New Frontier. It was a great morale boost for West Berliners, who lived in an enclave deep inside East Germany and feared a possible East German occupation.",
                "response":"Your answer is correct! The speech was a powerful symbol of America's support for West Berlin and its commitment to standing up against Soviet aggression."
            },
            {
                "id":2,
                "prompt":"Question?",
                "response":"How did John F Kennedy's presidency impact the civil rights movement in the United States?"
            },
            {
                "id":3,
                "prompt":"Kennedy defined the civil rights crisis as moral, as well as constitutional and legal. He announced that major civil rights legislation would be submitted to the Congress to guarantee equal access to public facilities, to end segregation in education, and to provide federal protection of the right to vote.",
                "response":"Your answer is correct. John F Kennedy's presidency did impact the civil rights movement in the United States by defining the civil rights crisis as a moral issue and proposing major civil rights legislation to Congress, including the Civil Rights Act of 1964 and the Voting Rights Act of 1965."
            }
        ]
    },    
    {
        "id":4,
        "topic":"Spain",
        "language":"English",
        "chatname":"Spain",
        "promptsandresponses":[
            {
                "id":0,
                "prompt":"Question?",
                "response":"What are some of the most popular traditional Spanish dishes?"
            },
            {
                "id":1,
                "prompt":"Tortilla Espanola",
                "response":`, paella, gazpacho, and churros are some of the most popular traditional Spanish dishes.
                \nYour answer is correct! These are indeed some of the most iconic dishes from Spain.`
            },
            {
                "id":2,
                "prompt":"Question?",
                "response":"What are some of the most popular festivals and celebrations in Spain?"
            },
            {
                "id":3,
                "prompt":"San Juan, Carnival",
                "response":", La Tomatina, Running of the Bulls, La Feria de Abril, and Semana Santa are some of the most popular festivals and celebrations in Spain."
            },
            {
                "id":4,
                "prompt":"Question?",
                "response":"What are some of the most famous landmarks and tourist attractions in Spain?"
            },
            {
                "id":4,
                "prompt":"La Sagrada Familia, Royal Palace of Madrid",
                "response":", Park Güell, Alhambra, La Rambla, La Catedral de Santiago de Compostela, Plaza Mayor, La Mezquita, and Park de la Ciudadela are some of the most famous landmarks and tourist attractions in Spain."
            }

        ]
    },    

    {
        "id":5,
        "topic":"Payton programming language",
        "language":"English",
        "chatname":"Payton interview questions",
        "promptsandresponses":[
            {
                "id":0,
                "prompt":"Question?",
                "response":"What are some unique features of Payton language that make it stand out compared to other programming languages?"
            },
            {
                "id":1,
                "prompt":"Easy to code and easy to read, object-oriented programming support, dynamic typing, automatic memory management",
                "response":", and cross-platform compatibility are some unique features of Payton language that make it stand out compared to other programming languages."
            },
            {
                "id":2,
                "prompt":"Question?",
                "response":"What are the advantages and disadvantages of using Payton language for developing web applications?"
            },
            {
                "id":3,
                "prompt":"Advantages are Less coding, library support. Disadvantage is that it is little bit slower.",
                "response":`Your answer is partially correct. Some advantages of using Python for developing web applications include:
                \n- Easy to learn and use
                \n- Large community and great documentation
                \n- Huge number of libraries and frameworks available
                \n- Cross-platform compatibility
                \n- Good for data analysis and scientific computing
                 \nHowever, one disadvantage of Python is that it can be slower compared to languages like C++ or Java. This can be overcome to some extent by using libraries and modules that are optimized for speed.`
            },
        ]
    },    
    {
        "id":6,
        "topic":"Picasso",
        "language":"English",
        "chatname":"Picasso",
        "promptsandresponses":[
            {
                "id":0,
                "prompt":"Question?",
                "response":"What was Picasso's most expensive painting sold at an auction?"
            },
            {
                "id":1,
                "prompt":"The year was 2010 and the painting called 'Nude, Green Leaves and Bust' became the most expensive Picasso painting ever sold. The price was $106 millions",
                "response":"Your answer is correct!"
            },
            {
                "id":2,
                "prompt":"Question?",
                "response":"What inspired Picasso to create his famous \"Blue Period\" paintings?"
            },
            {
                "id":3,
                "prompt":"Hailed as a defining moment in Pablo Picasso's artistic career, The Blue Period (1901-1904) was inspired by Picasso's own emotional turmoil and financial destitution.",
                "response":`Correct! Picasso's Blue Period was characterized by somber and melancholic paintings, reflecting the artist's personal struggles during that time. Well done!`
            },
            {
                "id":4,
                "prompt":"Question?",
                "response":"What was Picasso's relationship with Surrealism and how did it influence his work?"
            },
            {
                "id":4,
                "prompt":"During the 1920s, Picasso became closely involved with the French Surrealist group, and Picasso even claimed to have invented the term 'sur-real', which the Surrealists later adopted. But Picasso's relationship with Surrealism was complex and slippery, and he remained on the periphery of the Parisian Surrealist Group.",
                "response":"Your answer is generally correct. Picasso did have a close relationship with the Surrealist movement during the 1920s, and he did contribute to the development of Surrealist art. However, it is important to note that Picasso did not fully embrace Surrealist ideology and techniques, and he often maintained his own artistic style and vision. Additionally, Picasso's relationship with the Surrealists was sometimes strained, and he did not always agree with their ideas or methods. Overall, Picasso's connection to Surrealism was complex and multifaceted, and it had a significant impact on his work during this period."            },

        ]
    },    

]

export const mainlanguages = [
    {
        "id":0,
        "language":"English",
    },
    {
        "id":1,
        "language":"French",
    },
    {
        "id":2,
        "language":"German",
    },
    {
        "id":3,
        "language":"Portuguese",
    },
    {
        "id":4,
        "language":"Serbian",
    },
    {
        "id":5,
        "language":"Spanish",
    },

]